import script from "./OrganizationContractMainForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationContractMainForm.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationContractMainForm.vue?vue&type=style&index=0&id=1aacae7d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aacae7d"]])

export default __exports__